import {translation} from "@2d-front-monorepo/core";
import {JSX, memo, useMemo} from "react";
import AttachmentStatus from "../enums/AttachmentStatus";
import {attachmentStatusLabel, attachmentStatusName} from "../helpers/enumNaming";
import {Attachments} from "../index";
import IAttachments from "../interfaces/IAttachments";


function EntityStatusComponent({entity}: { entity: IAttachments }): JSX.Element | undefined {
	const status = entity.attachments.length <= 1
		? Attachments.getStatus(entity)
		: useMemo(() => Attachments.getStatus(entity), entity.attachments.map(x => x.status));

	if (status == AttachmentStatus.Undefined) {
		return undefined;
	}

	const pillClass = `pill__entity-status--${attachmentStatusName(status)}`;
	return (<div className={`pill ${pillClass} pill--small`}>{translation(attachmentStatusLabel(status))}</div>);
}

const MemoizedEntityStatusComponent: React.FC<{entity: IAttachments}> = memo(EntityStatusComponent);
export default MemoizedEntityStatusComponent;
